function rodiwoShowSteps(which, trigger){
  document.getElementById('steps-fast').classList.toggle('hidden', which !== 'fast');
  document.getElementById('steps-long').classList.toggle('hidden', which !== 'long');
  document.querySelectorAll('.toggle-btn').forEach(function(b){ b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
  if (trigger) { trigger.classList.add('active'); trigger.setAttribute('aria-pressed', 'true'); }
}
document.addEventListener('click', function(event){
  var btn = event.target.closest('[data-rodiwo-step-toggle]');
  if (!btn) return;
  event.preventDefault();
  rodiwoShowSteps(btn.getAttribute('data-rodiwo-step-toggle'), btn);
});
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); obs.unobserve(e.target); } });
  }, {threshold:0.12});
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
} else {
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('in-view'));
}